var map = {
	"./1. Chyba ulubione - 0 oryginał.png": 830,
	"./12. Spoko tylko widać krzesło ale - 1 wariacja.jpg": 782,
	"./13. Zrobione z góry i skraca nogi zatem może bez nóg - 1 wariacja - można jak coś jesio ująć za plecami i zrobić jak oparte.jpg": 79,
	"./2. Przeżyje nawet w całości - 0 oryginał.jpg": 412,
	"./3. Spoko w miarę - 0 oryginał.jpg": 967,
	"./4. Tu mi nie siedzi dół sukienki - 0 oryginał.jpg": 365,
	"./5. Nostalgia którą można jakoś jak coś poprzycinać - 0 oryginał.png": 561,
	"./7. Profesorskie, hehe no nie wiem - 0 oryginał.png": 267,
	"./8. Przeżyje nawet w całości nawet to.jpg": 544,
	"./9. Dziwne rąsie ale przeżyje...można jak coś kadrować - 0 oryginał.png": 391
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 925;